<template>
    <div class="coin-icon">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 259.56 261.6" style="enable-background:new 0 0 83 84;" xml:space="preserve" width="35px" height="35px">
            <g>
                <circle cx="121.65" cy="121.16" r="119.16"/>
                <path d="M134.71,257.44c-67.43,0-122.28-54.86-122.28-122.28S67.29,12.88,134.71,12.88s122.28,54.86,122.28,122.28-54.86,122.28-122.28,122.28ZM134.71,19.12c-63.98,0-116.04,52.06-116.04,116.04s52.06,116.04,116.04,116.04,116.04-52.05,116.04-116.04S198.7,19.12,134.71,19.12Z"/>
            </g>
            <path class="st0" fill="#fff" d="M129.43,50.5l12.35,38.02c.81,2.48,3.11,4.16,5.72,4.16h39.98c5.83,0,8.25,7.46,3.54,10.88l-32.34,23.5c-2.11,1.53-2.99,4.25-2.18,6.72l12.35,38.02c1.8,5.54-4.54,10.15-9.25,6.72l-32.34-23.5c-2.11-1.53-4.96-1.53-7.07,0l-32.34,23.5c-4.71,3.42-11.06-1.18-9.25-6.72l12.35-38.02c.81-2.48-.08-5.19-2.18-6.72l-32.34-23.5c-4.71-3.42-2.29-10.88,3.54-10.88h39.98c2.61,0,4.91-1.68,5.72-4.16l12.35-38.02c1.8-5.54,9.64-5.54,11.44,0Z"/>

        </svg>
    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
    }
}
</script>

<style lang="scss" scoped>
</style>
